import React from "react";
import GameDeposits from "../components/gamedeposit";
export function GamedepositPage(access) {
  return (
    <div>
      <GameDeposits read={access} />
    </div>
  );
}

export default GamedepositPage;
